<template>
  <div class="longda">
    <div class="banner">
      <img src="@/images/longda/banner.png" />
    </div>
    <div class="detail">
      <img class="detail-logo" :src="`${this.$imgHost}/${vinInfo.logoUrl}`" />
      <div>
        <div class="detail-title">
          {{ vinInfo.maker }} {{ vinInfo.series }} {{ vinInfo.year + "款" }}
        </div>
        <div class="detail-tips">
          {{ vinInfo.displacement }} / {{ vinInfo.transMission }} /
          {{ vinInfo.engineModel }}
        </div>
      </div>
    </div>
    <div class="list">
      <div class="list-tab">
        <div
          class="tab-item"
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ active: type === item }"
          @click="handleTab(item)"
        >
          {{ item }}
        </div>
      </div>
      <div class="list-item" v-for="item in wearPartList" :key="item.productType">
        <div class="item-title">
          <div class="item-line"></div>
          <span>{{ item.productType }}</span>
          <div class="item-line"></div>
        </div>
        <div
          class="item-box"
          v-for="child in item.productList"
          :key="child.id"
          @click="handleDetail(child)"
        >
          <img class="item-box-img" src="@/images/longda/list1.png" />
          <div class="item-box-detail">
            <div class="item-box-title">
              {{ child.productBrand }}（{{ child.productNumber }}）
            </div>
            <div class="item-box-content">产品类型：{{ child.productType }}</div>
            <div class="item-box-content">产品型号：{{ child.productModel }}</div>
            <div class="item-box-content">发动机型号：{{ child.engineModel }}</div>
            <div class="item-box-content">时间：{{ child.importDate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-placeholder safe-area-bottom"></div>
    <mt-popup v-model="visible" class="longda-popup">
      <div class="popup-header">
        <div class="popup-header-left copy" @click="handleCopy">
          <span>复制地址</span>
          <img src="@/images/longda/copy.png" />
        </div>
        <img class="popup-header-close" src="@/images/close.png" @click="handleClose" />
      </div>
      <div class="popup-content">
        <div class="popup-tab">
          <div
            class="popup-item"
            :class="{ 'popup-active': brandType === 1 }"
            @click="handleBrandTab(1)"
          >
            产品详情
          </div>
          <div
            class="popup-item"
            :class="{ 'popup-active': brandType === 2 }"
            @click="handleBrandTab(2)"
          >
            适用车型
          </div>
        </div>
        <template v-if="brandType === 1">
          <div class="popup-img">
            <img src="@/images/longda/list2.png" />
          </div>
          <div class="popup-title">
            <div class="popup-line"></div>
            <span>产品参数</span>
            <div class="popup-line"></div>
          </div>
          <div class="popup-list">
            <div class="popup-list-item">
              <div class="popup-list-label">品牌</div>
              <div class="popup-list-value">{{ brandItem.productBrand }}</div>
            </div>
            <div class="popup-list-item">
              <div class="popup-list-label">编号</div>
              <div class="popup-list-value">{{ brandItem.productNumber }}</div>
            </div>
            <div class="popup-list-item">
              <div class="popup-list-label">备注</div>
              <div class="popup-list-value">{{ brandItem.productNote }}</div>
            </div>
            <div class="popup-list-item">
              <div class="popup-list-label">产品型号</div>
              <div class="popup-list-value">{{ brandItem.productModel }}</div>
            </div>
          </div>
        </template>
        <template v-if="brandType === 2">
          <div class="brand">
            <div class="select-brand" @click="handleSelectBrand">
              <span>{{ selectBrand }}</span>
              <img src="@/images/longda/down.png" />
            </div>
            <div class="brand-table">
              <div class="row">
                <div class="cell table-header">品牌</div>
                <div class="cell table-header">车型</div>
                <div class="cell table-header">年份</div>
                <div class="cell table-header">排量</div>
              </div>
              <div class="maker-list">
                <div class="row" v-for="(item, index) in makerList" :key="index">
                  <div class="cell">{{ item.brand }}</div>
                  <div class="cell">{{ item.models }}</div>
                  <div class="cell">{{ item.year }}</div>
                  <div class="cell">{{ item.motor }}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </mt-popup>
    <mt-popup v-model="brandVisible" position="bottom">
      <div class="brand-picker">
        <div class="pikcer-header">
          <span @click="handleBrandConfirm">确定</span>
          <img src="@/images/close.png" @click="brandVisible = false" />
        </div>
        <mt-picker :slots="brandList" @change="brandChange"></mt-picker>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import Clipboard from 'clipboard'

export default {
  data () {
    return {
      vinInfo: {},
      tabList: [],
      wearPartList: [],
      type: '',
      visible: false,
      brandItem: {},
      brandType: 1,
      brandVisible: false,
      brandList: [],
      brandPicker: '',
      selectBrand: '',
      makerList: [],
      imgHost: `${location.protocol}//image.daishupei.com`
    }
  },
  created () {
    this.getVinInfo()
  },
  methods: {
    getVinInfo () {
      this.$get('/auto/h5/ld/vinGet', {
        vinCode: this.$route.query.vinCode
      }).then(({ data }) => {
        if (data.errCode === 0 && data.data) {
          this.vinInfo = data.data
          this.getWearPartTypeList()
        }
      })
    },
    getWearPartTypeList () {
      this.$get('/auto/h5/ld/wearPartTypeListGet', {
        levelId: this.vinInfo.levelId
      }).then(({ data }) => {
        if (data.errCode === 0 && data.data) {
          this.tabList = data.data
          this.type = this.tabList[0]
          this.getWearPartVO()
        }
      })
    },
    getWearPartVO () {
      this.$get('/auto/h5/ld/wearPartVOGet', {
        levelId: this.vinInfo.levelId,
        productType: this.type
      }).then(({ data }) => {
        if (data.errCode === 0 && data.data) {
          this.wearPartList = data.data
        }
      })
    },
    handleTab (type) {
      this.type = type
      this.getWearPartVO()
    },
    handleDetail (item) {
      this.brandType = 1
      this.brandItem = item
      this.getSuitBrandList()
      this.visible = true
    },
    handleBrandTab (type) {
      this.brandType = type
    },
    getSuitBrandList () {
      this.$get('/auto/h5/ld/suitBrandListGet', {
        id: this.brandItem.id
      }).then(({ data }) => {
        if (data.errCode === 0 && data.data) {
          this.brandList = [{ values: data.data }]
          this.selectBrand = data.data[0]
          this.getSuitMakerList()
        }
      })
    },
    getSuitMakerList () {
      this.$get('/auto/h5/ld/suitMakerListGet', {
        id: this.brandItem.id,
        brand: this.selectBrand
      }).then(({ data }) => {
        if (data.errCode === 0 && data.data) {
          this.makerList = data.data
        }
      })
    },
    handleClose () {
      this.visible = false
    },
    handleCopy () {
      const clipboard = new Clipboard('.copy', {
        text: (trigger) => {
          return window.location.href
        }
      })
      clipboard.on('success', (e) => {
        this.$toast('复制成功')
      })
      clipboard.on('error', (e) => {
        this.$toast('复制成功')
      })
    },
    handleSelectBrand () {
      this.brandVisible = true
      this.brandPicker.setValues([this.selectBrand])
    },
    brandChange (picker) {
      this.brandPicker = picker
    },
    handleBrandConfirm () {
      const values = this.brandPicker.getValues()
      this.selectBrand = values[0]
      this.getSuitMakerList()
      this.brandVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.longda {
  padding: 24px 32px 0;
  background: #f3f3f3;
  min-height: 100vh;
  * {
    box-sizing: border-box;
  }
  .banner {
    img {
      width: 100%;
      height: 352px;
    }
  }
  .detail {
    height: 148px;
    background: #ffffff;
    border-radius: 8px;
    margin-top: 24px;
    display: flex;
    padding: 28px 30px 0;
    .detail-logo {
      width: 40px;
      height: 40px;
    }
    .detail-title {
      font-weight: 500;
      font-size: 28px;
      color: #000000;
      line-height: 40px;
      margin-left: 14px;
    }
    .detail-tips {
      font-size: 28px;
      color: #666666;
      line-height: 40px;
      margin: 12px 0 0 14px;
    }
  }
  .list {
    border-radius: 8px;
    background: #ffffff;
    margin-top: 24px;
    box-shadow: 0px 6px 16px 0px rgba(236, 58, 58, 0.05);
    border-radius: 16px;
    padding-bottom: 38px;
    .list-tab {
      display: flex;
      .tab-item {
        flex: 1;
        height: 74px;
        line-height: 40px;
        font-size: 28px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #e5e5e5;
        border-left: 1px solid #fff;
        border-right: 1px solid #fff;
      }
      .active {
        font-weight: 500;
        font-size: 28px;
        color: #000000;
        position: relative;
        border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        border-bottom: 1px solid #fff;
        border-radius: 10px 10px 0 0;
        &::after {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: #ff4b4b;
        }
      }
    }
    .list-item {
      .item-title {
        font-size: 24px;
        color: #666666;
        line-height: 34px;
        margin-top: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        .item-line {
          width: 52px;
          height: 2px;
          border: 1px solid #e5e5e5;
        }
        span {
          margin: 0 12px;
        }
      }
      .item-box {
        margin: 24px 32px 0;
        padding: 24px;
        border-radius: 12px;
        border: 1px solid #e5e5e5;
        display: flex;
        .item-box-img {
          width: 208px;
          height: 208px;
          object-fit: cover;
        }
        .item-box-detail {
          margin-left: 24px;
          .item-box-title {
            width: 334px;
            font-weight: 500;
            font-size: 28px;
            color: #333333;
            line-height: 40px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .item-box-content {
            width: 334px;
            font-size: 24px;
            color: #666666;
            line-height: 34px;
            margin-top: 8px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .detail-placeholder {
    width: 100%;
    height: 24px;
    box-sizing: content-box;
  }
  .longda-popup {
    width: 686px;
    background: #ffffff;
    border-radius: 16px;
    .popup-header {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 32px;
      border-bottom: 2px solid #e5e5e5;
      .popup-header-left {
        font-weight: 500;
        font-size: 28px;
        color: #45b7ff;
        display: flex;
        align-items: center;
        img {
          width: 32px;
          height: 32px;
          margin-left: 16px;
        }
      }
      .popup-header-close {
        width: 32px;
        height: 32px;
      }
    }
    .popup-content {
      padding: 28px 32px 70px;
      .popup-tab {
        display: flex;
        .popup-item {
          flex: 1;
          height: 74px;
          line-height: 40px;
          font-size: 28px;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: center;
          border-bottom: 1px solid #e5e5e5;
          border-left: 1px solid #fff;
          border-right: 1px solid #fff;
        }
        .popup-active {
          font-weight: 500;
          font-size: 28px;
          color: #000000;
          position: relative;
          border-top: 1px solid #e5e5e5;
          border-left: 1px solid #e5e5e5;
          border-right: 1px solid #e5e5e5;
          border-bottom: 1px solid #fff;
          border-radius: 10px 10px 0 0;
        }
      }
      .popup-img {
        border: 1px solid #e5e5e5;
        border-top: none;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100%;
          height: 646px;
          object-fit: cover;
        }
      }
      .popup-title {
        font-size: 24px;
        color: #666666;
        line-height: 34px;
        margin-top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        .popup-line {
          width: 52px;
          height: 2px;
          border: 1px solid #e5e5e5;
        }
        span {
          margin: 0 12px;
        }
      }
      .popup-list {
        margin-top: 8px;
        .popup-list-item {
          display: flex;
          align-items: center;
          margin-top: 16px;
          font-size: 28px;
          color: #333333;
          .popup-list-label {
            width: 200px;
            height: 48px;
            background: #f5f5f5;
            border-radius: 4px 0px 0px 4px;
            text-align: center;
            line-height: 48px;
          }
          .popup-list-value {
            width: 400px;
            height: 48px;
            background: #ffffff;
            border-radius: 0px 8px 8px 0px;
            border: 1px solid #f5f5f5;
            line-height: 48px;
            padding-left: 52px;
          }
        }
      }
      .brand {
        border: 1px solid #e5e5e5;
        border-top: none;
        border-radius: 8px;
        padding: 0 12px;
        .select-brand {
          width: 100%;
          height: 94px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          color: #333333;
          img {
            width: 32px;
            height: 32px;
            margin-left: 6px;
          }
        }
        .brand-table {
          display: flex;
          flex-direction: column;

          .row {
            display: flex;
          }
          .maker-list {
            max-height: 796px;
            overflow-y: auto;
          }
          .cell {
            flex: 1;
            height: 64px;
            text-align: center;
            line-height: 64px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .table-header {
            background: #f5f5f5;
            border-radius: 8px 0px 0px 8px;
          }
        }
      }
    }
  }
  .brand-picker {
    width: 750px;
    .pikcer-header {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      font-size: 26px;
      color: #45b7ff;
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/longda/demo.vue